const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB h16 strokeCT>path ` + (props.className || '')}
    >
      <path
        d="M5.06349 10.7778L11.1587 5.44444M5.57143 5.88889H5.58159M10.6508 10.3333H10.661M15.2222 17V2.77778C15.2222 2.30628 15.0082 1.8541 14.6271 1.5207C14.2461 1.1873 13.7293 1 13.1905 1H3.03175C2.49289 1 1.97611 1.1873 1.59508 1.5207C1.21406 1.8541 1 2.30628 1 2.77778V17L4.55556 15.2222L8.11111 17L11.6667 15.2222L15.2222 17ZM6.07937 5.88889C6.07937 6.00676 6.02585 6.11981 5.93059 6.20316C5.83534 6.28651 5.70614 6.33333 5.57143 6.33333C5.43672 6.33333 5.30752 6.28651 5.21226 6.20316C5.11701 6.11981 5.06349 6.00676 5.06349 5.88889C5.06349 5.77101 5.11701 5.65797 5.21226 5.57462C5.30752 5.49127 5.43672 5.44444 5.57143 5.44444C5.70614 5.44444 5.83534 5.49127 5.93059 5.57462C6.02585 5.65797 6.07937 5.77101 6.07937 5.88889ZM11.1587 10.3333C11.1587 10.4512 11.1052 10.5643 11.01 10.6476C10.9147 10.731 10.7855 10.7778 10.6508 10.7778C10.5161 10.7778 10.3869 10.731 10.2916 10.6476C10.1964 10.5643 10.1429 10.4512 10.1429 10.3333C10.1429 10.2155 10.1964 10.1024 10.2916 10.0191C10.3869 9.93571 10.5161 9.88889 10.6508 9.88889C10.7855 9.88889 10.9147 9.93571 11.01 10.0191C11.1052 10.1024 11.1587 10.2155 11.1587 10.3333Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
